import { render, staticRenderFns } from "./FinacialInstitutionDetails.vue?vue&type=template&id=37d46354&"
import script from "./FinacialInstitutionDetails.vue?vue&type=script&lang=js&"
export * from "./FinacialInstitutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./FinacialInstitutionDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports